export const ufs = {
  AC: "AC",
  AL: "AL",
  AP: "AP",
  AM: "AM",
  BA: "BA",
  CE: "CE",
  DF: "DF",
  ES: "ES",
  GO: "GO",
  MA: "MA",
  MT: "MT",
  MS: "MS",
  MG: "MG",
  PA: "PA",
  PB: "PB",
  PR: "PR",
  PE: "PE",
  PI: "PI",
  RJ: "RJ",
  RN: "RN",
  RS: "RS",
  RO: "RO",
  RR: "RR",
  SC: "SC",
  SP: "SP",
  SE: "SE",
  TO: "TO"
};

export const documentTypes = {
  RG: "RG",
  PASSAPORTE: "PASSAPORTE",
  CNH: "CNH",
  CPF: "CPF",
  OAB: "OAB",
  CI: "CI"
};

export const genders = {
  MASCULINO: "MASCULINO",
  FEMININO: "FEMININO",
  INDEFINIDO: "INDEFINIDO"
};

export const status = {
  AGENDADO: "AGENDADO",
  CANCELADO: "CANCELADO",
  CANCELADO_VIA_SMS: "CANCELADO_VIA_SMS",
  CONFIRMADO: "CONFIRMADO",
  FALTOU: "FALTOU",
  AGUARDANDO_RECEPCAO: "AGUARDANDO_RECEPCAO",
  RECEPCAO: "RECEPCAO",
  AGUARDANDO_PRE_CONSULTA: "AGUARDANDO_PRE_CONSULTA",
  PRE_CONSULTA: "PRE_CONSULTA",
  AGUARDANDO_ATENDIMENTO: "AGUARDANDO_ATENDIMENTO",
  EM_ATENDIMENTO: "EM_ATENDIMENTO",
  AGUARDANDO_POS_CONSULTA: "AGUARDANDO_POS_CONSULTA",
  POS_CONSULTA: "POS_CONSULTA",
  ATENDIMENTO_COMPLETO: "ATENDIMENTO_COMPLETO",
  PRE_AGENDAMENTO: "PRE_AGENDAMENTO",
  AUSENTE_POS_CONSULTA: "AUSENTE_POS_CONSULTA",
  TRANSFERIDO: "TRANSFERIDO",
  REAGENDADO: "REAGENDADO",
  PAGAMENTO_AGUARDANDO: "PAGAMENTO_AGUARDANDO"
};

export function hasAction(status) {
  let withActions = [
    "AGENDADO",
    "PRE_AGENDAMENTO",
    "TRANSFERIDO",
    "REAGENDADO",
    "PAGAMENTO_AGUARDANDO"
  ];

  return withActions.some(it => it === status);
}

export function validCPF(strCPF) {
  var Soma;
  var Resto;
  var i;
  Soma = 0;
  if (strCPF == "00000000000") return false;
  if (strCPF == "11111111111") return false;
  if (strCPF == "22222222222") return false;
  if (strCPF == "33333333333") return false;
  if (strCPF == "44444444444") return false;
  if (strCPF == "55555555555") return false;
  if (strCPF == "66666666666") return false;
  if (strCPF == "77777777777") return false;
  if (strCPF == "88888888888") return false;
  if (strCPF == "99999999999") return false;

  for (i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

export function validEmail(strEmail) {
  //eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(strEmail).toLowerCase());
}
